import React from 'react';
import './HotspotOverlay.css';

const BAND_COLOR = {
  low: 'var(--unity-secondary-yellow)',
  moderate: 'var(--new-orange, #ffbc88)',
  high: 'var(--unity-primary-violet)',
};

// Shows the forward capture (mirrored to match the selfie view) with a colored,
// tappable hotspot per finding. Each finding carries its own normalized position
// (from face landmarks when available, else a fixed region), so this needs no
// landmark data and survives the persisted/downscaled photo.
const HotspotOverlay = ({ image, findings = [], activeId, onSelect }) => (
  <div className="hotspot">
    <div className="hotspot__mirror">
      {image && <img className="hotspot__img" src={image} alt="Your skin analysis" />}
      {findings.map((f) => {
        const c = f.position;
        if (!c) return null;
        return (
          <button
            key={f.concernId}
            type="button"
            className={`hotspot__dot${activeId === f.concernId ? ' is-active' : ''}`}
            style={{
              left: `${c.x * 100}%`,
              top: `${c.y * 100}%`,
              background: BAND_COLOR[f.band] || '#fff',
            }}
            onClick={() => onSelect && onSelect(f)}
            aria-label={f.label}
          />
        );
      })}
    </div>
  </div>
);

export default HotspotOverlay;
